import React, { useState } from "react";
import Modalform from "../Formularz/Modalform";

import { FiFacebook, FiInstagram } from "react-icons/fi";

import { images } from "../../constants";
import "./Footer.css";

const Footer = () => {
    const [openModal, setOpenModal] = useState(false);

    return (
        <div className="app__bg app__footer section__padding" id="contact">
            <div className="app__footer-links">
                <div className="app__footer-links_contact">
                    <h1 className="app__footer-headtext">Kontakt</h1>
                    <p>
                        <a href="tel:+48 733824051" className="p__opensans">
                            +48 733 824 051
                        </a>
                    </p>
                    <a
                        href="mailto:Pk@przemyslawkokocinski.pl"
                        className="p__opensans"
                    >
                        Pk@przemyslawkokocinski.pl
                    </a>
                </div>

                <div className="div-pionowo" />

                <div className="app__footer-links_logo">
                    <img src={images.logoo} alt="footer_logo" />
                    <p className="p__opensans">
                        &quot;NAUCZĘ CIĘ JAK{" "}
                        <span className="green2">ŚWIADOMIE</span> TRENOWAĆ I JAK
                        ZMIENIĆ NAWYKI ŻYWIENIOWE&quot;
                    </p>

                    <div className="footer_btn">
                        <button
                            onClick={() => setOpenModal(true)}
                            type="button"
                            className="footer_btn_custom"
                        >
                            PIERWSZA KONSULTACJA
                        </button>
                        <Modalform
                            open={openModal}
                            onClose={() => setOpenModal(false)}
                        />
                    </div>

                    <div className="app__footer-links_icons">
                        <a href="https://www.facebook.com/Kokocinskitreneridietetyk">
                            <FiFacebook />
                        </a>
                        <a href="https://www.instagram.com/przemekokocinski">
                            <FiInstagram />
                        </a>
                    <hr className="poziomo" />
                    </div>
                </div>
<div className="div-pionowo" />
                <div className="app__footer-links_work">
                    <h1 className="app__footer-headtext">Lokalizacja</h1>
                    <p className="p__opensans">Fabryka Formy</p>
                    <p className="p__opensans">
                        Górnośląska 82
                        <br />
                        62-800 Kalisz
                    </p>
                    {/* <p className="p__opensans">62-800 Kalisz</p> */}
                </div>
            </div>

            <div className="footer__copyright">

                <p className="p__opensans">2023 All Rights reserved.</p>
            </div>
        </div>
    );
};

export default Footer;
